angular.module('iw.frontyard.signup')
    .service('FrontyardVersionProvider', function () {

        class FrontyardVersionProvider {

            static getFileHashPath() {
                return 'frontyard/frontyard.js';
            }

            static getVersionHash() {
                var regExp = /frontyard\/frontyard-?(.*)\.js/i;
                var fileHashPath = FrontyardVersionProvider.getFileHashPath();

                if (regExp.test(fileHashPath)) {
                    return fileHashPath.match(regExp, '$1')[1];
                }

                return '';
            }
        }

        return FrontyardVersionProvider;
    });
